import type { DeviceRegistration, DeviceRegistrationRequest } from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

export function registerDevice(
  transport: Transport,
  { deviceRegistration }: { deviceRegistration: DeviceRegistrationRequest["deviceRegistration"] },
): Promise<DeviceRegistration> {
  return operations.postDeviceRegistration(transport, { body: { deviceRegistration } });
}
